import React, { useState } from 'react';

function Departments({ showToast }) {
  const [showModal, setShowModal] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'

  const [departments, setDepartments] = useState([
    {
      id: 1,
      code: 'IT',
      name: 'Công nghệ thông tin',
      description: 'Quản lý hệ thống CNTT, phát triển ứng dụng',
      managerName: 'Nguyễn Văn A',
      employeeCount: 15,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 2,
      code: 'CREDIT',
      name: 'Tín dụng',
      description: 'Thẩm định, phê duyệt và quản lý khoản vay',
      managerName: 'Trần Thị B',
      employeeCount: 45,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 3,
      code: 'RISK',
      name: 'Quản lý Rủi ro',
      description: 'Đánh giá và giám sát rủi ro tín dụng',
      managerName: 'Lê Văn C',
      employeeCount: 12,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 4,
      code: 'FINANCE',
      name: 'Kế toán Tài chính',
      description: 'Quản lý tài chính, kế toán tổng hợp',
      managerName: 'Phạm Thị D',
      employeeCount: 20,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 5,
      code: 'HR',
      name: 'Nhân sự',
      description: 'Quản lý nguồn nhân lực, tuyển dụng, đào tạo',
      managerName: 'Hoàng Văn E',
      employeeCount: 8,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 6,
      code: 'LEGAL',
      name: 'Pháp chế',
      description: 'Tư vấn pháp lý, soạn thảo hợp đồng',
      managerName: 'Đỗ Thị F',
      employeeCount: 6,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 7,
      code: 'MARKETING',
      name: 'Marketing',
      description: 'Tiếp thị, truyền thông, phát triển sản phẩm',
      managerName: 'Vũ Văn G',
      employeeCount: 10,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    },
    {
      id: 8,
      code: 'OPERATIONS',
      name: 'Vận hành',
      description: 'Quản lý hoạt động nghiệp vụ ngân hàng',
      managerName: 'Bùi Thị H',
      employeeCount: 35,
      status: 'Hoạt động',
      createdDate: '01/01/2024'
    }
  ]);

  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    managerName: '',
    status: 'Hoạt động'
  });

  const filterDepartments = () => {
    return departments.filter(dept => {
      const matchesSearch = dept.name.toLowerCase().includes(searchText.toLowerCase()) ||
        dept.code.toLowerCase().includes(searchText.toLowerCase()) ||
        dept.managerName.toLowerCase().includes(searchText.toLowerCase());
      const matchesStatus = !statusFilter || dept.status === statusFilter;
      return matchesSearch && matchesStatus;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const openCreateModal = () => {
    setEditingDepartment(null);
    setFormData({
      code: '',
      name: '',
      description: '',
      managerName: '',
      status: 'Hoạt động'
    });
    setShowModal(true);
  };

  const openEditModal = (department) => {
    setEditingDepartment(department);
    setFormData({
      code: department.code,
      name: department.name,
      description: department.description,
      managerName: department.managerName,
      status: department.status
    });
    setShowModal(true);
  };

  const handleSaveDepartment = (e) => {
    e.preventDefault();
    
    if (editingDepartment) {
      // Update existing department
      setDepartments(departments.map(dept =>
        dept.id === editingDepartment.id
          ? { ...dept, ...formData }
          : dept
      ));
      showToast('Cập nhật phòng ban thành công', 'success');
    } else {
      // Create new department
      const newDepartment = {
        id: Math.max(...departments.map(d => d.id), 0) + 1,
        ...formData,
        employeeCount: 0,
        createdDate: new Date().toLocaleDateString('vi-VN')
      };
      setDepartments([...departments, newDepartment]);
      showToast('Thêm phòng ban mới thành công', 'success');
    }
    
    setShowModal(false);
  };

  const deleteDepartment = (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa phòng ban này?')) {
      setDepartments(departments.filter(dept => dept.id !== id));
      showToast('Xóa phòng ban thành công', 'success');
    }
  };

  const getTotalEmployees = () => {
    return departments.reduce((sum, dept) => sum + dept.employeeCount, 0);
  };

  const getActiveCount = () => {
    return departments.filter(dept => dept.status === 'Hoạt động').length;
  };

  const filteredDepartments = filterDepartments();

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="page-header-sticky">
        <div>
          <h2 className="mb-1">
            <i className="bi bi-diagram-3 me-2"></i>
            Quản lý Phòng ban
          </h2>
          <p className="text-muted mb-0">Quản lý cơ cấu tổ chức và phòng ban trong ngân hàng</p>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Tổng phòng ban</h6>
                  <h3 className="mb-0">{departments.length}</h3>
                </div>
                <div className="text-primary">
                  <i className="bi bi-diagram-3 fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Đang hoạt động</h6>
                  <h3 className="mb-0 text-success">{getActiveCount()}</h3>
                </div>
                <div className="text-success">
                  <i className="bi bi-check-circle fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Tổng nhân viên</h6>
                  <h3 className="mb-0">{getTotalEmployees()}</h3>
                </div>
                <div className="text-info">
                  <i className="bi bi-people fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">TB nhân viên/PB</h6>
                  <h3 className="mb-0">{Math.round(getTotalEmployees() / departments.length)}</h3>
                </div>
                <div className="text-warning">
                  <i className="bi bi-calculator fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filters and Actions */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-5">
              <label className="form-label">Tìm kiếm</label>
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm theo tên, mã, trưởng phòng..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Trạng thái</label>
              <select 
                className="form-select"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">Tất cả trạng thái</option>
                <option value="Hoạt động">Hoạt động</option>
                <option value="Tạm dừng">Tạm dừng</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Hiển thị</label>
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-2 text-end">
              <label className="form-label">&nbsp;</label>
              <button 
                className="btn btn-primary w-100"
                onClick={openCreateModal}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Thêm phòng ban
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Departments Table */}
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Mã</th>
                  <th>Tên phòng ban</th>
                  <th>Mô tả</th>
                  <th>Trưởng phòng</th>
                  <th className="text-center">Số nhân viên</th>
                  <th className="text-center">Trạng thái</th>
                  <th className="text-center">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredDepartments.length > 0 ? (
                  filteredDepartments.map(dept => (
                    <tr key={dept.id}>
                      <td>
                        <span className="badge bg-secondary">{dept.code}</span>
                      </td>
                      <td>
                        <strong>{dept.name}</strong>
                      </td>
                      <td>
                        <small className="text-muted">{dept.description}</small>
                      </td>
                      <td>
                        <i className="bi bi-person-badge me-1"></i>
                        {dept.managerName}
                      </td>
                      <td className="text-center">
                        <span className="badge bg-info">{dept.employeeCount}</span>
                      </td>
                      <td className="text-center">
                        <span className={`badge bg-${dept.status === 'Hoạt động' ? 'success' : 'warning'}`}>
                          {dept.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => openEditModal(dept)}
                          title="Chỉnh sửa"
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => deleteDepartment(dept.id)}
                          title="Xóa"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-4">
                      <i className="bi bi-inbox fs-1"></i>
                      <p className="mt-2">Không tìm thấy phòng ban nào</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingDepartment ? 'Chỉnh sửa phòng ban' : 'Thêm phòng ban mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSaveDepartment}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Mã phòng ban <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="code"
                        className="form-control"
                        value={formData.code}
                        onChange={handleInputChange}
                        placeholder="VD: IT, CREDIT"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Tên phòng ban <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="VD: Công nghệ thông tin"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Mô tả</label>
                      <textarea
                        name="description"
                        className="form-control"
                        rows="3"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Mô tả chức năng, nhiệm vụ của phòng ban..."
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Trưởng phòng</label>
                      <input
                        type="text"
                        name="managerName"
                        className="form-control"
                        value={formData.managerName}
                        onChange={handleInputChange}
                        placeholder="Họ tên trưởng phòng"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Trạng thái</label>
                      <select
                        name="status"
                        className="form-select"
                        value={formData.status}
                        onChange={handleInputChange}
                      >
                        <option value="Hoạt động">Hoạt động</option>
                        <option value="Tạm dừng">Tạm dừng</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowModal(false)}
                  >
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i>
                    {editingDepartment ? 'Cập nhật' : 'Thêm mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Departments;
